import {
  Component,
  ViewChild,
  OnInit,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { MatPaginator, MatSort, PageEvent } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { Router, ParamMap } from '@angular/router';
import { DatePipe } from '@angular/common';

import { AppStateService } from '../services/app-state.service';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../services/data.service';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/merge';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'timereport',
  templateUrl: './timereport.component.html',
  styleUrls: ['./timereport.component.scss']
})
export class TimereportComponent implements OnInit {

  constructor( private router: Router,
    private route: ActivatedRoute,
    private appState: AppStateService,
    private dataService: DataService, private authService: AuthService) { }

    private trId;
    private trSubscription;
    private canChangeUser = false;

    private _sentDates;
    get sentDates(): Set<number> {
      return this._sentDates;
    }


    public timereport;

  ngOnInit() {

    this.authService.userHasPermission('app.timereport.anyone.write').subscribe(val => {
      this.canChangeUser = val;
    });

    this.trSubscription = this.route.paramMap
      .filter((params: ParamMap) => params.has('id'))
      .switchMap((params: ParamMap) => {
        this.trId = params.get('id');
        console.log('TR ID', this.trId);
        return this.dataService.getTimeReport(this.trId);
      })
      .subscribe((timereport) => {
        console.log('TR', timereport);
          if (!timereport) {
            this.appState.showError({ errorCode: -1, errorMessage: 'Unable to find this timereport id' });
            this.router.navigate(['/timereport']);
          } else if (!this.canChangeUser && timereport.sent) {
              // A norma  user cannot edit this timereport then navigate back to the list
              this.router.navigate(['/timereport']);
        } else {
            timereport.id = this.trId;
            this.timereport = timereport;
            console.log('Timereport set', timereport);
          }
        });


    // Subscribe to already sent email
    this.dataService.getReportEmailByUser(this.authService.currentUser)
    .map((emailReports) => {
      return new Set(emailReports.filter((er: any) => er.reportDate).map((er: any) => er.reportDate.valueOf()));
    }).subscribe((set) => {
      this._sentDates = set;
      // console.log(this._sentDates);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/timereport/timereport.component.ts